import reducer, { actions } from './slice';
import * as asyncActions from './asyncActions';

export const organizationProjectClassStore = {
  actions,
  asyncActions,
};

export default reducer;
